import React from 'react';

const G = '#4A7A3A';
const FILL = 'rgba(74,122,58,0.15)';
const FILL2 = 'rgba(74,122,58,0.2)';

export function IconToday({ size = 22, color = G, active }) {
  const s = active ? 2 : 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="9" fill={active ? FILL2 : FILL} stroke={color} strokeWidth={s}/>
      <path d="M8 12l3 3 5-5" stroke={color} strokeWidth={s} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function IconJournal({ size = 22, color = G, active }) {
  const s = active ? 2 : 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" fill={active ? FILL2 : FILL} stroke={color} strokeWidth={s} strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4 19.5A2.5 2.5 0 016.5 17H20" stroke={color} strokeWidth={s} strokeLinecap="round"/>
      <path d="M9 7h6M9 11h4" stroke={color} strokeWidth={s} strokeLinecap="round"/>
    </svg>
  );
}

export function IconGoals({ size = 22, color = G, active }) {
  const s = active ? 2 : 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="9" fill={active ? FILL2 : FILL} stroke={color} strokeWidth={s}/>
      <circle cx="12" cy="12" r="5" fill={FILL} stroke={color} strokeWidth={s}/>
      <circle cx="12" cy="12" r="2" fill={color}/>
    </svg>
  );
}

export function IconLibrary({ size = 22, color = G, active }) {
  const s = active ? 2 : 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M4 19V5a1 1 0 011-1h4v15H5a1 1 0 01-1-1z" fill={active ? FILL2 : FILL} stroke={color} strokeWidth={s} strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9 4h5l1 15H9V4z" fill={FILL} stroke={color} strokeWidth={s} strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M15 5.5l3.5-.8a1 1 0 011.2.7l2.8 12a1 1 0 01-.7 1.2l-4 .9" stroke={color} strokeWidth={s} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function IconProfile({ size = 22, color = G, active }) {
  const s = active ? 2 : 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="8" r="4" fill={active ? FILL2 : FILL} stroke={color} strokeWidth={s}/>
      <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" fill={FILL} stroke={color} strokeWidth={s} strokeLinecap="round"/>
    </svg>
  );
}

export function IconMeditation({ size = 28, color = G }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M12 3c0 0-4 3-4 7s4 5 4 5 4-1 4-5-4-7-4-7z" fill={FILL2} stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8 14c-2 1-3 2.5-3 4h14c0-1.5-1-3-3-4" fill={FILL} stroke={color} strokeWidth={1.5} strokeLinecap="round"/>
    </svg>
  );
}

export function IconMovement({ size = 28, color = G }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="4" r="2" fill={color} opacity="0.8"/>
      <path d="M6 8l3 2 1 4-2 5" stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M15 8l-2 2.5L12 14l2 5" stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7 13h4" stroke={color} strokeWidth={1.5} strokeLinecap="round"/>
    </svg>
  );
}

export function IconYoga({ size = 28, color = G }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="4" r="1.5" fill={color} opacity="0.8"/>
      <path d="M12 6v5l-4 3M12 11l4 3" stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8 9l-3 2M16 9l3 2" stroke={color} strokeWidth={1.5} strokeLinecap="round"/>
      <path d="M10 19l2-3 2 3" stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function IconNutrition({ size = 28, color = G }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M12 2c-4 0-7 3-7 7 0 5 3 8 7 13 4-5 7-8 7-13 0-4-3-7-7-7z" fill={FILL2} stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 2c0 4-2 6-2 9" stroke={color} strokeWidth={1.5} strokeLinecap="round"/>
    </svg>
  );
}

export function IconSleep({ size = 28, color = G }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" fill={FILL2} stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function IconPen({ size = 28, color = G }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" fill={FILL} stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" fill={FILL2} stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function IconSun({ size = 28, color = G }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="5" fill={FILL2} stroke={color} strokeWidth={1.5}/>
      <path d="M12 2v2M12 20v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M2 12h2M20 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" stroke={color} strokeWidth={1.5} strokeLinecap="round"/>
    </svg>
  );
}

export function IconBreathing({ size = 28, color = G }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M12 2C8 2 5 5 5 9c0 2.5 1 4.5 2.5 6" stroke={color} strokeWidth={1.5} strokeLinecap="round"/>
      <path d="M12 2c4 0 7 3 7 7 0 2.5-1 4.5-2.5 6" stroke={color} strokeWidth={1.5} strokeLinecap="round"/>
      <path d="M9.5 15C8 16.5 8 18 9 19.5c1 1.5 3 2 3 2s2-.5 3-2c1-1.5 1-3-.5-4.5" fill={FILL2} stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="12" cy="12" r="2" fill={FILL2} stroke={color} strokeWidth={1.5}/>
    </svg>
  );
}

export function IconHeart({ size = 28, color = G }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" fill={FILL2} stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function IconStar({ size = 28, color = G }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M12 2l3 7h7l-5.5 4 2 7L12 16l-6.5 4 2-7L2 9h7z" fill={FILL2} stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function IconBook({ size = 28, color = G }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M4 19.5A2.5 2.5 0 016.5 17H20" stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" fill={FILL2} stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function IconMindfulness({ size = 28, color = G }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="9" fill={FILL} stroke={color} strokeWidth={1.5}/>
      <circle cx="12" cy="12" r="4" fill={FILL2} stroke={color} strokeWidth={1.5}/>
      <circle cx="12" cy="12" r="1" fill={color}/>
    </svg>
  );
}

export function IconHabits({ size = 28, color = G }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <rect x="3" y="4" width="18" height="16" rx="3" fill={FILL} stroke={color} strokeWidth={1.5}/>
      <path d="M8 2v4M16 2v4M3 10h18" stroke={color} strokeWidth={1.5} strokeLinecap="round"/>
      <path d="M8 14l2 2 4-4" stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function IconMental({ size = 28, color = G }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M12 2a7 7 0 017 7c0 2.5-1.5 4.5-3 6l-1 3H9l-1-3C6.5 13.5 5 11.5 5 9a7 7 0 017-7z" fill={FILL2} stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9 18h6M10 21h4" stroke={color} strokeWidth={1.5} strokeLinecap="round"/>
    </svg>
  );
}

export function IconSpirituality({ size = 28, color = G }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M12 2l2 7h7l-5.5 4 2 6L12 15l-5.5 4 2-6L3 9h7z" fill={FILL2} stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function IconFitness({ size = 28, color = G }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M6 4v16M18 4v16" stroke={color} strokeWidth={1.5} strokeLinecap="round"/>
      <path d="M2 8v8M22 8v8" stroke={color} strokeWidth={1.5} strokeLinecap="round"/>
      <path d="M6 12h12" stroke={color} strokeWidth={2} strokeLinecap="round"/>
    </svg>
  );
}

export function IconSuccess({ size = 28, color = G }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4h7.6z" fill={FILL2} stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function IconNutritionCat({ size = 28, color = G }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M18 8h1a4 4 0 010 8h-1" fill={FILL} stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2 8h16v9a4 4 0 01-4 4H6a4 4 0 01-4-4V8z" fill={FILL2} stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6 2v4M10 2v4M14 2v4" stroke={color} strokeWidth={1.5} strokeLinecap="round"/>
    </svg>
  );
}

export function IconCheck({ size = 20, color = G }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="9" fill={FILL2} stroke={color} strokeWidth={1.5}/>
      <path d="M8 12l3 3 5-5" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function IconBell({ size = 20, color = G }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9" fill={FILL2} stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M13.73 21a2 2 0 01-3.46 0" stroke={color} strokeWidth={1.5} strokeLinecap="round"/>
    </svg>
  );
}

export function IconUser({ size = 20, color = G }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="8" r="4" fill={FILL2} stroke={color} strokeWidth={1.5}/>
      <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" fill={FILL} stroke={color} strokeWidth={1.5} strokeLinecap="round"/>
    </svg>
  );
}

export function IconShop({ size = 20, color = G }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" fill={FILL} stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M3 6h18" stroke={color} strokeWidth={1.5} strokeLinecap="round"/>
      <path d="M16 10a4 4 0 01-8 0" stroke={color} strokeWidth={1.5} strokeLinecap="round"/>
    </svg>
  );
}

export function IconArrow({ size = 16, color = G }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M5 12h14M12 5l7 7-7 7" stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function IconPlus({ size = 16, color = G }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="9" fill={FILL} stroke={color} strokeWidth={1.5}/>
      <path d="M12 8v8M8 12h8" stroke={color} strokeWidth={1.5} strokeLinecap="round"/>
    </svg>
  );
}

export function IconTrash({ size = 16, color = '#C07070' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6" stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function IconEdit({ size = 16, color = G }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" stroke={color} strokeWidth={1.5} strokeLinecap="round"/>
      <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke={color} strokeWidth={1.5} strokeLinecap="round"/>
    </svg>
  );
}

// Map habit name to the right icon
export function getHabitIcon(name = '', size = 28, color = G) {
  const n = name.toLowerCase();
  if (n.includes('meditat') || n.includes('stillness') || n.includes('witness') || n.includes('lotus')) return <IconMeditation size={size} color={color} />;
  if (n.includes('movement') || n.includes('walk') || n.includes('workout') || n.includes('run') || n.includes('exercise') || n.includes('cardio') || n.includes('zone 2')) return <IconMovement size={size} color={color} />;
  if (n.includes('yoga') || n.includes('stretch') || n.includes('flow') || n.includes('pose') || n.includes('asana')) return <IconYoga size={size} color={color} />;
  if (n.includes('nutrition') || n.includes('food') || n.includes('eat') || n.includes('water') || n.includes('hydrat') || n.includes('meal') || n.includes('diet')) return <IconNutrition size={size} color={color} />;
  if (n.includes('sleep') || n.includes('rest') || n.includes('night') || n.includes('bed') || n.includes('nsdr') || n.includes('nidra')) return <IconSleep size={size} color={color} />;
  if (n.includes('journal') || n.includes('write') || n.includes('reflect') || n.includes('free write')) return <IconPen size={size} color={color} />;
  if (n.includes('morning') || n.includes('intention') || n.includes('sun') || n.includes('light') || n.includes('circadian')) return <IconSun size={size} color={color} />;
  if (n.includes('breath') || n.includes('wim') || n.includes('cold') || n.includes('shower')) return <IconBreathing size={size} color={color} />;
  if (n.includes('heart') || n.includes('emotion') || n.includes('love') || n.includes('gratitude') || n.includes('grateful')) return <IconHeart size={size} color={color} />;
  if (n.includes('goal') || n.includes('vision') || n.includes('target') || n.includes('achiev')) return <IconGoals size={size} color={color} />;
  return <IconStar size={size} color={color} />;
}

// Map book category to icon
export function getCategoryIcon(category = '', size = 22, color = G) {
  switch(category) {
    case 'mindfulness': return <IconMindfulness size={size} color={color} />;
    case 'habits': return <IconHabits size={size} color={color} />;
    case 'mental': return <IconMental size={size} color={color} />;
    case 'spirituality': return <IconSpirituality size={size} color={color} />;
    case 'fitness': return <IconFitness size={size} color={color} />;
    case 'nutrition': return <IconNutritionCat size={size} color={color} />;
    case 'success': return <IconSuccess size={size} color={color} />;
    default: return <IconBook size={size} color={color} />;
  }
}
